import { Component, Input } from '@angular/core';
import { BarDefinition } from './bar-definition';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'tnb-simple-bars',
    templateUrl: './simple-bars.component.html',
    styleUrls: [
        './simple-bars.component.scss',
    ],
    standalone: false,
})
export class SimpleBarsComponent {

    public ASSET_URL = environment.ASSET_URL;

    @Input()
    public bars: BarDefinition[];

    constructor() {
    }

}
